import React from "react";
import styles from "../styles_home/ClientReview.module.css";
import { FaQuoteLeft, FaStar } from "react-icons/fa";

const ClientReview = () => {
  const reviews = [
    {
      name: "Danish Khan",
      position: "CEO, OasisBulls",
      review:
        "The innovative solutions provided by the team revolutionized our workflow. We've seen a remarkable 40% boost in productivity since implementation.",
      rating: 5,
      bgColor: "#4F46E5",
    },
    {
      name: "Simran Jain",
      position: "CEO, NavkarMasala",
      review:
        "Their technical prowess is unmatched. The team delivered a sophisticated solution that exceeded our expectations in both performance and scalability.",
      rating: 5,
      bgColor: "#0EA5E9",
    },
    {
      name: "Prakash Koli",
      position: "Director, Vittpath",
      review:
        "Exceptional delivery and outstanding support. The team's proactive approach and attention to detail made the entire process seamless and efficient.",
      rating: 5,
      bgColor: "#8B5CF6",
    },
  ];

  return (
    <section className={styles.reviewSection}>
      <div className={styles.container}>
        <div className={styles.header}>
        <h2 className={styles.sectionTitle}>Client Testimonials</h2>
          <p>See what our happy clients have to say about us</p>
        </div>

        <div className={styles.reviewWrapper}>
          {reviews.map((review, index) => (
            <div className={styles.reviewCard} key={index}>
              <div className={styles.quoteIcon}>
                <FaQuoteLeft />
              </div>
              <p className={styles.reviewText}>{review.review}</p>
              <div className={styles.rating}>
                {[...Array(review.rating)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
              <div className={styles.reviewer}>
                <div
                  className={styles.avatar}
                  style={{ backgroundColor: review.bgColor }}
                >
                  {review.name.charAt(0)}
                </div>
                <div className={styles.reviewerInfo}>
                  
                  <p>{review.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientReview;
